import { Block, cloneBlock } from '@chameleoncreator/creator-app';
import { createBlock } from './block';
import { reverse } from './interactions/interaction';

export type contentFor = (i: number) => () => Block;

export const createLayout = (
  content: (i: number) => () => Block,
  count: number,
  reversed: boolean
): Block => {
  const layout = [
    (content: contentFor, reversed: boolean): Block => {
      return createBlock(
        'SingleColumnLayout',
        reverse(
          createBlock('Column', [content(0)()]),
          createBlock('Column', [content(1)()]),
          reversed
        )
      );
    },
    (content: contentFor, reversed: boolean) => {
      return createBlock(
        'TwoColumnLayout',
        reverse(
          createBlock('Column', [content(0)()]),
          createBlock('Column', [content(1)()]),
          reversed
        )
      );
    },
  ];

  return layout[count](content, reversed);
};

// returns a new block to be saved
// TODO: Implement
const swapColumnOrder = (block: Block): Block => {
  const newBlock = cloneBlock(block);
  const newChildren = [
    newBlock.children![1] as Block,
    newBlock.children![0] as Block,
  ];
  newBlock.children = newChildren;

  return newBlock;
};

// returns a new block to be saved
const changeColumnCount = (block: Block, count: number): Block => {
  const newBlock = cloneBlock(block);

  if (count === 2) {
    newBlock.type = 'TwoColumnLayout';
  } else {
    newBlock.type = 'SingleColumnLayout';
  }
  return newBlock;
};

const isOneColumn = (str: string): boolean => {
  if (str.includes('OneColumn')) {
    return true;
  }

  return false;
};

const isReversed = (str: string): boolean => {
  if (str.includes('Reversed')) {
    return true;
  }

  return false;
};

export const changeLayout = (
  block: Block,
  currentLayout: string,
  change: string
): Block => {
  // console.log(currentLayout, change);

  let newBlock = block;
  if (currentLayout === change) {
    return block;
  }

  if (isReversed(currentLayout) !== isReversed(change)) {
    newBlock = swapColumnOrder(newBlock);
  }

  if (isOneColumn(currentLayout) !== isOneColumn(change)) {
    if (isOneColumn(change)) {
      newBlock = changeColumnCount(block, 1);
    } else {
      newBlock = changeColumnCount(block, 2);
    }
  }

  return newBlock;
};
